/* Quantity-break behaviour. Moved out of snippets/quantity-break.liquid on 2026-09-06 so it is cached instead of inlined (44 KB) on every product view.
   Product/config data is emitted by the snippet as window.OPT_QB right before this script tag. */
var OPT_QB = window.OPT_QB || {};
document.addEventListener('DOMContentLoaded', function() {
    var quantitySelectors = document.querySelectorAll('.quantity-break-option');
    var quantityInputs = document.querySelectorAll('.quantity-break-input');
    var shouldUpdatePrice = OPT_QB.shouldUpdatePrice;
    var enableVariantSelection = OPT_QB.enableVariantSelection;
    var showRadioButtons = OPT_QB.showRadioButtons;
    var enableCustomPricing = OPT_QB.enableCustomPricing;
    var productVariants = OPT_QB.productVariants;
    var hasVariants = OPT_QB.hasVariants;
    const simpleVariantPickerRadioInputs = document.querySelectorAll('.simple-variant-picker__radio');

    // Debug logging
    void('Quantity Break Debug:', {
      enableVariantSelection: enableVariantSelection,
      hasVariants: hasVariants,
      quantitySelectors: quantitySelectors.length,
      variantContainers: document.querySelectorAll('.quantity-break-variant-container').length,
      variantSelections: document.querySelectorAll('.quantity-break-variant-selection').length,
      selectedOptions: document.querySelectorAll('.quantity-break-option.selected').length
    });

    // Check if variant containers are properly set up
    document.querySelectorAll('.quantity-break-variant-container').forEach((container, index) => {
      const hasCustomSelectors = container.getAttribute('data-has-custom-selectors');
      const variantSelection = container.querySelector('.quantity-break-variant-selection');
      const selectors = container.querySelectorAll('.quantity-break-variant-select, .quantity-break-color-swatch-input');
      void(`Variant container ${index}:`, {
        hasCustomSelectors,
        hasVariantSelection: !!variantSelection,
        selectorsCount: selectors.length,
        parentSelected: container.closest('.quantity-break-option')?.classList.contains('selected')
      });
    });
    
    // Find the product form
    const form = document.querySelector('form[action*="/cart/add"]:not(.free-product-form):not(.shipping-protection-form)');
    
    // Helper function to add quantity element
    function addQuantityElem(quantity) {
      if (!form) return;
      const existingQuantityInputs = form.querySelectorAll('input[name="quantity"]');
      existingQuantityInputs.forEach(input => {
        if (input.type === 'hidden') input.remove();
      });
      const quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';
      quantityInput.value = quantity;
      form.appendChild(quantityInput);
    }
    
    // Get button text and format money function from global scope or define defaults
    var addToCartButtonText = (typeof window.addToCartButtonText !== 'undefined') ? window.addToCartButtonText : 'Add to Cart';
    function formatMoneyWithoutSuffix(amount) {
      if (typeof window.formatMoneyWithoutSuffix === 'function') {
        return window.formatMoneyWithoutSuffix(amount);
      }
      return amount;
    }

    document.querySelectorAll('.quantity-break-option-container').forEach(container => {
      const quantityOption = container.getAttribute('data-option-quantity');
      const rows = container.querySelectorAll('.quantity-break-variant-selectors');
      rows.forEach((row, idx) => {
        row.setAttribute('data-quantity-option', quantityOption);
        row.setAttribute('data-item-index', String(idx + 1));
      });
    });



    function slugify(s){
      return (s || '')
        .toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g,'') // strip accents
        .replace(/[^a-z0-9]+/g,'-')
        .replace(/^-+|-+$/g,'');
    }

    function usesCustomSelectorsForSelectedOption() {
      const selected = document.querySelector('.quantity-break-option.selected');
      if (!selected) return false;
      
      // Check for variant container within the same option container
      const optionContainer = selected.closest('.quantity-break-option-container');
      if (!optionContainer) return false;
      
      const variantContainer = optionContainer.querySelector('.quantity-break-variant-container');
      if (variantContainer) {
        const flag = variantContainer.getAttribute('data-has-custom-selectors');
        if (flag === 'true' || flag === true) return true;
      }
      
      // Also check directly for variant selectors as fallback
      return !!optionContainer.querySelector('.quantity-break-variant-selectors');
    }

    const hasSimplePicker = !!document.querySelector('.simple-variant-picker__container');
    function qbControlsOption(quantityOption, itemIndex, position) {
      return !!document.querySelector(
        // Selects QB
        `.quantity-break-variant-select[data-quantity-option="${quantityOption}"][data-item-index="${itemIndex}"][data-option-selector="${position}"],` +
        // Radios QB (swatches et images)
        `input.quantity-break-color-swatch-input[data-quantity-option="${quantityOption}"][data-item-index="${itemIndex}"][data-option-selector="${position}"],` +
        `input.quantity-break-variant-image-input[data-quantity-option="${quantityOption}"][data-item-index="${itemIndex}"][data-option-selector="${position}"]`
      );
    }
      
    

    function getOptionValue(quantityOption, itemIndex, position, optionName) {
    // 1) Priorité : QB s'il gère cette option
    if (qbControlsOption(quantityOption, itemIndex, position)) {
      // Radio QB cochée ?
      const qbRadio = document.querySelector(
        `input[data-quantity-option="${quantityOption}"][data-item-index="${itemIndex}"][data-option-selector="${position}"]:checked`
      );

      if (qbRadio) return (qbRadio.dataset.optionValue || qbRadio.value || '').trim();

      // Select QB ?
      const qbSelect = document.querySelector(
        `.quantity-break-variant-select[data-quantity-option="${quantityOption}"][data-item-index="${itemIndex}"][data-option-selector="${position}"]`
      );

      if (qbSelect && qbSelect.value) return qbSelect.value.trim();

      return ''; // QB contrôle mais rien sélectionné
    }

    // 2) Sinon, on lit dans le simple variant picker (s'il existe)
    if (hasSimplePicker) {
      // Radio simple picker par position
      const spRadio = document.querySelector(
        `.simple-variant-picker__radio[data-option-position="${position}"]:checked`
      );
      if (spRadio) return spRadio.value.trim();
      // Select simple picker par position
      const spSelect = document.querySelector(
        `.simple-variant-picker__select[data-option-position="${position}"]`
      );
      if (spSelect && spSelect.value) return spSelect.value.trim();

      // Fallback par name (au cas où)
      if (optionName) {
        const byNameRadio = document.querySelector(
          `input[name="options[${CSS.escape(optionName)}]"]:checked`
        );
        if (byNameRadio) return byNameRadio.value.trim();

        const byNameSelect = document.querySelector(
          `select[name="options[${CSS.escape(optionName)}]"]`
        );
        if (byNameSelect && byNameSelect.value) return byNameSelect.value.trim();
      }
    }

    // 3) Rien trouvé
    return '';
  }

  




    const firstVisibleOption = OPT_QB.firstVisibleOption;

    if (quantitySelectors[firstVisibleOption - 1]) {
      // Select the first option immediately without delay
      setTimeout(function() {
        quantitySelectors[firstVisibleOption - 1].click();

        // Double-check that it's selected
        setTimeout(function() {
          const selected = document.querySelector('.quantity-break-option.selected');
          if (selected) {
            const variantContainer = selected.closest('.quantity-break-option-container')?.querySelector('.quantity-break-variant-container');
            if (variantContainer) {
              const variantSelection = variantContainer.querySelector('.quantity-break-variant-selection');
              if (variantSelection) {
                const computedStyle = window.getComputedStyle(variantSelection);
                void('Variant selection styles:', {
                  opacity: computedStyle.opacity,
                  maxHeight: computedStyle.maxHeight,
                  display: computedStyle.display
                });
              }
            }
          }
        }, 200);
      }, 100); // Reduced delay from 500ms to 100ms
    }

    var variantOptions = [];
    var variantImages = {};
    
    variantOptions = OPT_QB.variantOptions.slice();
    
    // Create a mapping of variant IDs to their images
    Object.assign(variantImages, OPT_QB.variantImages);
    
    // Log initial state for debugging
    
    function formatPrice(originPrice, newPriceValue) {
      let priceValue = (newPriceValue / 100).toFixed(2).toString();
      if (originPrice.includes(",")) priceValue = priceValue.replace(".", ",");
      const originPriceNumber = originPrice.replace(/[^0-9.,]/g, '');

      return originPrice.replace(originPriceNumber.toString(), priceValue);
    }

    // Function to update variant images based on current selections
    function updateVariantImages(quantityOption, itemIndex) {
      const selectedByPos = {};
      for (let pos = 1; pos <= variantOptions.length; pos++) {
        const val = getOptionValue(quantityOption, itemIndex, pos, variantOptions[pos - 1]);
        if (val) selectedByPos[pos] = val;
      }

      const matchedVariant = productVariants.find(v =>
        Object.keys(selectedByPos).every(pos => v[`option${pos}`] === selectedByPos[pos])
      );

      const row = document.querySelector(
        `.quantity-break-variant-selectors[data-quantity-option="${quantityOption}"][data-item-index="${itemIndex}"]`
      );
      const img = row ? row.querySelector('.quantity-break-variant-image img') : null;

      if (matchedVariant && variantImages[matchedVariant.id] && img) {
        img.src = variantImages[matchedVariant.id].src;
        img.alt = variantImages[matchedVariant.id].alt;
      }
    }


    // Function to update selected variant name display
   function updateVariantNameDisplay(quantityOption, itemIndex) {
    const parts = [];
    for (let pos = 1; pos <= variantOptions.length; pos++) {
      const val = getOptionValue(quantityOption, itemIndex, pos, variantOptions[pos - 1]);
      if (val) parts.push(val);
    }
    const row = document.querySelector(
      `.quantity-break-variant-selectors[data-quantity-option="${quantityOption}"][data-item-index="${itemIndex}"]`
    );
    const el = row ? row.querySelector('.selected-variant-name') : null;
   
    if (el) el.textContent = parts.length ? `(${parts.join(' / ')})` : '';
     void(el.textContent)
  }


    function switchRowImage(quantityOption, itemIndex, src, altText) {
  const row = document.querySelector(
    `.quantity-break-variant-selectors[data-quantity-option="${quantityOption}"][data-item-index="${itemIndex}"]`
  );
  const img = row ? row.querySelector('.quantity-break-variant-image img') : null;
  if (img && src) {
    img.src = src;
    img.alt = altText || '';
  }
  } 

  function activateMediaById(mediaId) {
    const thumb = document.querySelector(`.shop-thumbnail[data-media-id="${mediaId}"]`);
    if (thumb) {
      thumb.click(); // pilote la galerie si thumbs actifs
      return true;
    }
    return false;
    }

        // Handle option selection
        quantitySelectors.forEach(option => {
          option.addEventListener('click', function(e) {

            // If radio buttons are visible, only proceed if the click is on the radio button or label
            if (showRadioButtons) {
              var clickedRadio = e.target.closest('.quantity-break-radio-container');
              if (!clickedRadio && e.target.tagName !== 'INPUT') {
                return; // Only respond to clicks on radio buttons when they're shown
              }
            }

            // Continue with normal selection logic
            quantitySelectors.forEach(opt => {
              opt.classList.remove('selected');
            });
            this.classList.add('selected');

            // Debug logging
            const variantContainer = this.closest('.quantity-break-option-container')?.querySelector('.quantity-break-variant-container');
            if (variantContainer) {
            }

            var input = this.querySelector('input');
            if (!input) return;
            input.checked = true;

            // Get current prices and quantity
            const curPriceEl = this.querySelector(".quantity-break-price");
            const curCompareEl = this.querySelector(".quantity-break-original-price");
            const curPrice = curPriceEl ? curPriceEl.innerHTML : "";
            const curComparePrice = curCompareEl ? curCompareEl.innerHTML : "";
            const currentQuantity = input.value;

            // Update product price display
            const productPriceLabel = document.querySelector(".shop-product-price-block");
            const comparePriceLabel = document.querySelector(".shop-compare-price");
            if (productPriceLabel) productPriceLabel.innerHTML = curPrice;
            if (comparePriceLabel) comparePriceLabel.innerHTML = curComparePrice;

            // Update form quantity
            if (form) {
              form.querySelectorAll('input[type="hidden"][name="quantity"]').forEach(el => el.remove());
              addQuantityElem(currentQuantity);
              form.setAttribute('data-quantity', currentQuantity);
            }

            // Find and update product quantity input
            var quantityInput = document.querySelector('input[name="quantity"]:not([type="hidden"])');
            if (quantityInput) {
              quantityInput.value = currentQuantity;
              var event = new Event('change', { bubbles: true });
              quantityInput.dispatchEvent(event);
            }

            // Update Add to Cart button text
            const addToCartButton = document.querySelector('.product-form__submit .button__text')
              || document.querySelector('.shop-add-to-cart-button .button-text')
              || document.querySelector('[data-add-to-cart-text]');
            
            if (addToCartButton) {
              const submitButton = addToCartButton.closest('button[type="submit"]') || addToCartButton.closest('.shop-add-to-cart-button');
              const hasTextOverride = submitButton && submitButton.dataset.textOverride === 'true';
              const persistentText = submitButton && submitButton.dataset.persistentText;
              
              // Respect text override - use persistent text if available
              let buttonText = '';
              if (hasTextOverride && persistentText) {
                buttonText = persistentText;
              } else {
                buttonText = addToCartButtonText || 'Add to Cart';
              }
              
              let newButtonText = buttonText;
              if (typeof showPriceInButton !== 'undefined' && showPriceInButton && curPrice) {
                newButtonText += ' - ' + formatMoneyWithoutSuffix(curPrice.replace(/[^0-9.,]/g, ''));
                if (curComparePrice) {
                  newButtonText += ` <span class="compare-price">(${formatMoneyWithoutSuffix(curComparePrice.replace(/[^0-9.,]/g, ''))})</span>`;
                }
              }
              
              addToCartButton.innerHTML = newButtonText;
            }

            // Always update variant selections to ensure items are added to cart
            updateVariantSelections();

            // Only update display if custom selectors are enabled
            if (enableVariantSelection && hasVariants && usesCustomSelectorsForSelectedOption()) {
              setTimeout(updateSimpleVariantPickerDisplay, 100);
            } else {
              // Clean up stale variant forms
              const stale = document.querySelector('.quantity-break-variant-form');
              if (stale) stale.remove();
            }

            // Trigger change event to update cart
            if (shouldUpdatePrice && typeof window.updatePrice === 'function') {
              window.updatePrice(input.dataset.price);
            }

            // Dispatch custom event for other scripts to listen to
            document.dispatchEvent(new CustomEvent('quantity_break:changed', {
              detail: {
                quantity: parseInt(input.value),
                price: parseInt(input.dataset.price)
              }
            }));
          });
        });
        
        // Handle variant selection changes
        
        if (enableVariantSelection && hasVariants ) {
          var variantSelects = document.querySelectorAll('.quantity-break-variant-select');
          
          
          variantSelects.forEach(select => {
            select.addEventListener('change', function() {
              // Get the data attributes
              var quantityOption = this.getAttribute('data-quantity-option');
              var itemIndex = this.getAttribute('data-item-index');
              
              // Update the variant image for this specific item
              updateVariantImages(quantityOption, itemIndex);
              // Update the variant name display
              updateVariantNameDisplay(quantityOption, itemIndex);
               // Also update the overall variant selections
            updateVariantSelections();
            
            // Update simple variant picker display
            updateSimpleVariantPickerDisplay();
            });
          });
          
          // Initialize images and variant names for all items
          setTimeout(function() {
            variantSelects.forEach(select => {
              var quantityOption = select.getAttribute('data-quantity-option');
              var itemIndex = select.getAttribute('data-item-index');
              updateVariantImages(quantityOption, itemIndex);
              updateVariantNameDisplay(quantityOption, itemIndex);
            });
          }, 100);
        }
        if (enableVariantSelection && hasVariants) {

          var variantSwatches = document.querySelectorAll('.quantity-break-color-swatch-input');

              variantSwatches.forEach(swatch => {
                swatch.addEventListener('change', function () {
                  var quantityOption = this.getAttribute('data-quantity-option');
                  var itemIndex      = this.getAttribute('data-item-index');

                  // Récupère les data du label associé
                  const label = document.querySelector(`label[for="${this.id}"]`);
                  const mediaId  = label?.dataset.mediaId;
                  const mediaSrc = label?.dataset.mediaSrc;

                  // 1) Affiche l'image près des sélecteurs de variantes (petite vignette de ligne)
                  if (mediaSrc) {
                    switchRowImage(quantityOption, itemIndex, mediaSrc, this.value);
                  }

                  // 2) (Optionnel) Synchronise la galerie principale
                  if (mediaId) {
                    activateMediaById(mediaId);
                  }

                  // Ta logique existante :
                  updateVariantImages(quantityOption, itemIndex);
                  updateVariantNameDisplay(quantityOption, itemIndex);
                  updateVariantSelections();
                });
          });
        }
        updateVariantSelections()
        
        
        // Initialize - update product quantity input with selected quantity
        var selectedBundleInput = document.querySelector('.quantity-break-option.selected input.quantity-break-input');

        if (selectedBundleInput) {
          var quantityInput = document.querySelector('input[name="quantity"]');
          if (quantityInput) {
            quantityInput.value = selectedBundleInput.value;
            quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          if (shouldUpdatePrice && typeof window.updatePrice === 'function') {
            window.updatePrice(selectedBundleInput.dataset.price);
          }
        }
        
        // Function to get selected variants
        function getSelectedVariants() {
          const selectedBundleInput = document.querySelector('.quantity-break-option.selected input.quantity-break-input');
          if (!selectedBundleInput) return [[], 0, 0];

          const quantityOption = selectedBundleInput.value;
          const optionQuantity = parseInt(quantityOption, 10);

          // Helper: récupère la variante correspondant aux valeurs de l'item i
          const pickVariantForItem = (i) => {
            // Check for a forced variant ID pinned in theme settings
            var selectedOptionContainer = document.querySelector('.quantity-break-option.selected')?.closest('.quantity-break-option-container');
            var forcedVariantId = selectedOptionContainer ? selectedOptionContainer.getAttribute('data-forced-variant-id') : null;
            if (forcedVariantId) {
              var forced = productVariants.find(function(v){ return String(v.id) === String(forcedVariantId); });
              if (forced) return forced;
            }
            const sel = {};
            let has = false;
            for (let pos = 1; pos <= variantOptions.length; pos++) {
              const v = getOptionValue(quantityOption, i, pos, variantOptions[pos - 1]);
              if (v) { sel[`option${pos}`] = v; has = true; }
            }
            if (!has) return OPT_QB.cloneSelected();
            const m = productVariants.find(v => Object.keys(sel).every(k => v[k] === sel[k]));
            return m || OPT_QB.cloneSelected();
          };

          if (optionQuantity <= 1) {
            const v = pickVariantForItem(1);
            return [[v.id], v.price, v.compare_at_price || 0];
          }

          const ids = [];
          let total = 0, totalCompare = 0;
          for (let i = 1; i <= optionQuantity; i++) {
            const v = pickVariantForItem(i);
            ids.push(v.id);
            total += v.price;
            totalCompare += (v.compare_at_price || 0);
          }
          return [ids, total, totalCompare];
    }

      

      // Function to update variant selections in the cart form
      function updateVariantSelections() {
        const [selectedVariants, totalPrice, totalComparePrice] = getSelectedVariants();

        if (selectedVariants.length > 0) {
          // Get the selected bundle input to check for custom pricing
          const selectedBundleInput = document.querySelector('.quantity-break-option.selected input.quantity-break-input');
          const hasCustomPricing = selectedBundleInput && selectedBundleInput.getAttribute('data-enable-custom-pricing') === 'true';
          // final_price is already in cents, so we need to parse it as integer
          const customPrice = selectedBundleInput ? parseInt(selectedBundleInput.getAttribute('data-custom-price'), 10) || 0 : 0;
          const quantityOption = selectedBundleInput ? parseInt(selectedBundleInput.value, 10) : 0;
          
          var upsellCheckbox = document.querySelector('[data-upsell-checkbox]');
          var isUpsellActive = upsellCheckbox ? upsellCheckbox.checked : false;
          var upsellVariantId = upsellCheckbox ? upsellCheckbox.getAttribute('data-variant-id') : null;

          if (isUpsellActive && upsellVariantId) {
            selectedVariants.push(upsellVariantId);
          }

          // Add all items to cart (including free ones for "Buy X Get Y Free" promotions)
          // The custom pricing will be handled by discount apps or backend logic
          const quantityList = Object.values(
            selectedVariants.reduce((acc, id) => {
              if (!acc[id]) {
                acc[id] = { id, quantity: 1 };
              } else {
                acc[id].quantity += 1;
              }
              return acc;
            }, {})
          );

          // First remove any existing input
          var existingContainer = document.querySelector('.quantity-break-variant-form');
          if (existingContainer) {
            existingContainer.parentNode.removeChild(existingContainer);
          }
          
          const premiumKitItems = document.querySelectorAll('.product-variant-premium-kit');
          const premiumKitLength = premiumKitItems.length;
          
          // Create a new input element
          const container = document.createElement('div');
          container.classList.add('quantity-break-variant-form');
        
          let index = premiumKitLength + 1;
          quantityList.forEach(_item => {
            const inputId = document.createElement('input');
            inputId.type = 'hidden';
            inputId.name = `items[${index}][id]`;
            inputId.value = _item.id;
            inputId.classList.add('product-variant-id');
            inputId.classList.add('product-variant-quantity-break');

            const inputQuantity = document.createElement('input');
            inputQuantity.type = 'hidden';
            inputQuantity.name = `items[${index}][quantity]`;
            inputQuantity.value = _item.quantity;
            inputQuantity.classList.add('product-variant-id');
            
            // If custom pricing is enabled, add the custom price as a property
            // This allows discount apps or custom logic to apply the correct total price
            if (hasCustomPricing && customPrice > 0 && index === premiumKitLength + 1) {
              // Add custom price property to the first item
              const inputProperties = document.createElement('input');
              inputProperties.type = 'hidden';
              inputProperties.name = `items[${index}][properties][_custom_total_price]`;
              inputProperties.value = (customPrice / 100).toFixed(2);
              container.appendChild(inputProperties);
              
              // Also add quantity option for reference
              const inputQuantityOption = document.createElement('input');
              inputQuantityOption.type = 'hidden';
              inputQuantityOption.name = `items[${index}][properties][_quantity_option]`;
              inputQuantityOption.value = quantityOption;
              container.appendChild(inputQuantityOption);
            }
            
            container.appendChild(inputId);
            container.appendChild(inputQuantity);
            index ++;
          })
          
          // Find the cart form
          const productForm = document.querySelector('form[action*="/cart/add"]:not(.free-product-form):not(.shipping-protection-form)');
          if (productForm) {
            productForm.appendChild(container);

            // Remove the main variant ID input since we're using items[] format
            // But we need to ensure items[] inputs are properly created first
            if (selectedVariants.length > 0 && container.children.length > 0) {
              var mainVariantInput = productForm.querySelector('input[name="id"]');
              if (mainVariantInput) {
                mainVariantInput.remove();
              }
            }

            const selectedBundle = document.querySelector('.quantity-break-option.selected input.quantity-break-input');
            if (!selectedBundle) return;

            // quantité choisie (ex: "3", "6", "9")
            const quantityOption = selectedBundle?.value;

            document
              .querySelectorAll(`.quantity-break-variant-selectors[data-quantity-option="${quantityOption}"]`)
              .forEach(row => {
                const idx = row.getAttribute('data-item-index');   // "1", "2", "3", ...
                // facultatif : si tu veux aussi resynchroniser l’image de ligne
                // updateVariantImages(quantityOption, idx);
                updateVariantImages(quantityOption, idx);
                updateVariantNameDisplay(quantityOption, idx);
              });
            
          } else {
          }

          const selectedOption = document.querySelector('.quantity-break-option.selected input')?.parentElement;
          

          if (!selectedOption) return;
          
          // Only update prices automatically if custom pricing is NOT enabled
          if (!enableCustomPricing) {
            const priceLabel = selectedOption.querySelector(".quantity-break-price");
            const originPrice = priceLabel.innerText;
            const totalPriceLabel = formatPrice(originPrice, totalPrice);
            if (priceLabel) priceLabel.innerHTML = totalPriceLabel;
            const compareLabel = selectedOption.querySelector(".quantity-break-original-price");
            const totalComparePriceLabel = formatPrice(originPrice, totalComparePrice);
            if (compareLabel) compareLabel.innerHTML = totalComparePriceLabel;
            if (totalComparePrice == 0 && compareLabel) {
              compareLabel.style.visibility = "hidden";
            } else if (totalComparePrice > totalPrice && compareLabel) {
              compareLabel.style.visibility = "visible";
            }

            const productPriceLabel = document.querySelector(".shop-product-price-block");
            const comparePriceLabel = document.querySelector(".shop-compare-price");

            if (productPriceLabel)
              productPriceLabel.innerHTML = totalPriceLabel;
            if (totalComparePrice > totalPrice && comparePriceLabel)
              comparePriceLabel.innerText = totalComparePriceLabel;

            let buttonText = addToCartButtonText || 'Add to Cart';
            buttonText += " - " + totalPriceLabel;
            if (totalComparePrice > totalPrice) {
              buttonText += ` <span class="compare-price">(${totalComparePriceLabel})</span>`;
            }

            const addToCartButton = document.querySelector('.product-form__submit .button__text') || 
                                    document.querySelector('.shop-add-to-cart-button .button-text') ||
                                    document.querySelector('[data-add-to-cart-text]');
            if (!addToCartButton) return;    

            addToCartButton.innerHTML = buttonText;
          }
        }
      }

 

      if (simpleVariantPickerRadioInputs) {
        simpleVariantPickerRadioInputs.forEach(input => {
  input.addEventListener('change', () => {
    const selectedBundle = document.querySelector('.quantity-break-option.selected input.quantity-break-input');
    const quantityOption = selectedBundle?.value;
    if (!quantityOption) return;

    // Récupérer la position et valeur qui a changé
    const changedPosition = input.getAttribute('data-option-position');
    const changedValue = input.value;
    
    // Mettre à jour tous les sélecteurs QB correspondants
    updateQuantityBreakSelectors(quantityOption, changedPosition, changedValue);
    
    // Mettre à jour les affichages
    updateAllQuantityBreakDisplays(quantityOption);
    
    // Recalculer les sélections
    updateVariantSelections();
  });
});

function updateQuantityBreakSelectors(quantityOption, position, value) {
  // Mettre à jour tous les selects
  document.querySelectorAll(
    `.quantity-break-variant-select[data-quantity-option="${quantityOption}"][data-option-selector="${position}"]`
  ).forEach(select => {
    if (Array.from(select.options).some(opt => opt.value === value)) {
      select.value = value;
    }
  });

  // Mettre à jour tous les radio buttons (swatches)
  document.querySelectorAll(
    `.quantity-break-color-swatch-input[data-quantity-option="${quantityOption}"][data-option-selector="${position}"]`
  ).forEach(swatch => {
    const swatchValue = swatch.getAttribute('data-option-value') || swatch.value;
    swatch.checked = (swatchValue === value);
  });

  // Mettre à jour les images de variants
  document.querySelectorAll(
    `.quantity-break-variant-image-input[data-quantity-option="${quantityOption}"][data-option-selector="${position}"]`
  ).forEach(imageInput => {
    const imageValue = imageInput.getAttribute('data-option-value') || imageInput.value;
    imageInput.checked = (imageValue === value);
  });
}

function updateAllQuantityBreakDisplays(quantityOption) {
  const rows = document.querySelectorAll(
    `.quantity-break-variant-selectors[data-quantity-option="${quantityOption}"]`
  );
  
  rows.forEach(row => {
    const itemIndex = row.getAttribute('data-item-index');
    updateVariantImages(quantityOption, itemIndex);
    updateVariantNameDisplay(quantityOption, itemIndex);
  });
}
      }
      

      // Listen for product variant changeßs
      document.addEventListener('variant:changed', function(event) {
      
        
        // Refresh the selected quantity on variant change to maintain user selection
        var selectedQuantityBreak = document.querySelector('.quantity-break-option.selected input');
        
        if (selectedQuantityBreak) {
          var quantityInput = document.querySelector('input[name="quantity"]');
          if (quantityInput) {
            quantityInput.value = selectedQuantityBreak.value;
          }
          
          // Update default selection for first item in each variant selector
          if (enableVariantSelection && hasVariants && event.detail && event.detail.variant) {
            var variant = event.detail.variant;
            variantOptions.forEach(function(option, index) {
              if (variant['option' + (index + 1)]) {
                var firstItemSelects = document.querySelectorAll('.quantity-break-variant-select[data-option-selector="' + (index + 1) + '"][data-item-index="1"]');
                firstItemSelects.forEach(function(select) {
                  for (var i = 0; i < select.options.length; i++) {
                    if (select.options[i].value === variant['option' + (index + 1)]) {
                      select.selectedIndex = i;
                      break;
                    }
                  }
                });
              }
            });
            
            // Also update all variant images and names
            setTimeout(function() {
              variantSelects.forEach(select => {
                var quantityOption = select.getAttribute('data-quantity-option');
                var itemIndex = select.getAttribute('data-item-index');
                updateVariantImages(quantityOption, itemIndex);
                updateVariantNameDisplay(quantityOption, itemIndex);
              });
            }, 100);
            
            updateVariantSelections();
          }
        }
      });
      
      // Function to update simple variant picker display
      function updateSimpleVariantPickerDisplay() {
          if (!enableVariantSelection || !hasVariants || !usesCustomSelectorsForSelectedOption()) return;
        
        // Get the selected quantity break option
        var selectedOption = document.querySelector('.quantity-break-option.selected input');
        if (!selectedOption) return;
        
        var quantityOption = selectedOption.getAttribute('value');
        
        // Get all variant selects for the selected quantity option
        var variantSelects = document.querySelectorAll('.quantity-break-variant-select[data-quantity-option="' + quantityOption + '"]');
        
        variantSelects.forEach(function(select) {
          var optionPosition = select.getAttribute('data-option-selector');
          var selectedValue = select.value;
          
          if (selectedValue && optionPosition) {
            // Update the simple variant picker's selected variant display
            var selectedVariantLabel = document.querySelector('.simple-variant-picker__selected-variant[data-option-position="' + optionPosition + '"]');
            if (selectedVariantLabel) {
              // Check if this is a size option for abbreviation
              var optionName = select.getAttribute('data-option-name') || '';
              var displayValue = optionName.toLowerCase().includes('size') ? 
                getAbbreviatedSize(selectedValue, optionName) : selectedValue;
              selectedVariantLabel.textContent = displayValue;
            }
            
            // Also update the radio button selection in simple variant picker
            var radioButton = document.querySelector('input[name="options[' + optionName + ']"][value="' + selectedValue + '"]');
            if (radioButton && !radioButton.checked) {
              radioButton.checked = true;
            }
          }
        });
      }
      
      // Helper function for size abbreviation (copied from simple variant picker)
      function getAbbreviatedSize(size, optionName) {
        if (!optionName.toLowerCase().includes('size')) return size;
        
        const sizeMap = {
          'Extra Small': 'XS',
          'Small': 'S', 
          'Medium': 'M',
          'Large': 'L',
          'Extra Large': 'XL',
          'XX-Large': 'XXL',
          'XXX-Large': 'XXXL'
        };
        
        return sizeMap[size] || size;
      }

      // Initialize variant selections if enabled
      if (enableVariantSelection && hasVariants && usesCustomSelectorsForSelectedOption()) {
        updateVariantSelections();
        setTimeout(updateSimpleVariantPickerDisplay, 200);
      }
      
      // Function to detect when quantity break titles wrap to multiple lines
      function checkTitleWrapping() {
        const titleContainers = document.querySelectorAll('.quantity-break-title-container');
        
        titleContainers.forEach(function(container) {
          const title = container.querySelector('.quantity-break-title');
          const badge = container.querySelector('.quantity-break-save-badge');
          
          if (title && badge) {
            // Create a temporary element to measure single-line height
            const tempElement = title.cloneNode(true);
            tempElement.style.position = 'absolute';
            tempElement.style.visibility = 'hidden';
            tempElement.style.height = 'auto';
            tempElement.style.width = 'auto';
            tempElement.style.whiteSpace = 'nowrap';
            tempElement.style.maxWidth = 'none';
            document.body.appendChild(tempElement);
            
            const singleLineHeight = tempElement.offsetHeight;
            document.body.removeChild(tempElement);
            
            // Compare actual height with single-line height
            const actualHeight = title.offsetHeight;
            const isWrapped = actualHeight > singleLineHeight + 2; // +2px tolerance
            
            if (isWrapped) {
              container.classList.add('title-wrapped');
            } else {
              container.classList.remove('title-wrapped');
            }
          }
        });
      }
      
      // Check title wrapping on load
      checkTitleWrapping();
      
      // Check title wrapping on window resize
      window.addEventListener('resize', function() {
        clearTimeout(window.titleWrapTimeout);
        window.titleWrapTimeout = setTimeout(checkTitleWrapping, 100);
      });

      // Function to check if variant options wrapped to separate lines
      function checkVariantWrapping(fullWidthWrapper) {
        if (!fullWidthWrapper) return;
        
        const swatchesContainer = fullWidthWrapper.querySelector('.quantity-break-color-swatches-wrapped');
        const variantOptions = fullWidthWrapper.querySelector('.quantity-break-variant-options-inline');
        
        if (!swatchesContainer || !variantOptions) return;
        
        // Get the bottom position of the swatches container
        const swatchesRect = swatchesContainer.getBoundingClientRect();
        const variantRect = variantOptions.getBoundingClientRect();
        
        // If variant options are more than 5px below the swatches, they've wrapped
        const hasWrapped = variantRect.top > swatchesRect.bottom + 5;
        
        if (hasWrapped) {
          variantOptions.classList.add('wrapped');
        } else {
          variantOptions.classList.remove('wrapped');
        }
      }

      // Ensure color swatches are full-width and variant selects appear beneath them
      function layOutSwatchesAndSelects() {
        const swatchContainers = document.querySelectorAll('.quantity-break-color-swatches');
        swatchContainers.forEach(function(container) {
          // Skip if already processed
          const variantSelectors = container.closest('.quantity-break-variant-selectors');
          if (!variantSelectors || variantSelectors.classList.contains('quantity-break-swatches-processed')) return;

          // Create full-width wrapper and move swatches into it
          const fullWidthWrapper = document.createElement('div');
          fullWidthWrapper.className = 'quantity-break-color-swatches-full-width';
          container.classList.add('quantity-break-color-swatches-wrapped');
          fullWidthWrapper.appendChild(container);
          variantSelectors.parentNode.insertBefore(fullWidthWrapper, variantSelectors.nextSibling);

          // Move the variant selects inline with the swatches
          const variantRight = variantSelectors.querySelector('.quantity-break-variant-right');
          if (variantRight) {
            const inlineOptions = document.createElement('div');
            inlineOptions.className = 'quantity-break-variant-options-inline';
            // Move all variant options to the inline container
            while (variantRight.firstChild) {
              inlineOptions.appendChild(variantRight.firstChild);
            }
            fullWidthWrapper.appendChild(inlineOptions);
          }

          // Mark as processed
          variantSelectors.classList.add('quantity-break-swatches-processed');

          // Check if variants wrapped to separate lines
          checkVariantWrapping(fullWidthWrapper);
        });
      }

      // Run on load and resize
      layOutSwatchesAndSelects();
      window.addEventListener('resize', function(){
        clearTimeout(window.qbLayoutTimeout);
        window.qbLayoutTimeout = setTimeout(function() {
          layOutSwatchesAndSelects();
          // Also check variant wrapping on resize
          document.querySelectorAll('.quantity-break-color-swatches-full-width').forEach(checkVariantWrapping);
        }, 100);
      });
      
    });
